// Custom Input for DatePicker (Date)
import {forwardRef} from "react";
import {Calendar, Clock} from "lucide-react";

export const CustomDateInput = forwardRef<HTMLButtonElement, { value?: string; onClick?: () => void }>(({
                                                                                                            value,
                                                                                                            onClick
                                                                                                        }, ref) => (
    <button
        type="button"
        className="flex items-center justify-between w-full text-left space-x-2 bg-slate-700 px-3 py-2 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        onClick={onClick}
        ref={ref}
    >
        <span>{value || 'YYYY-MM-DD'}</span>
        <Calendar size={18} className="text-white"/>
    </button>
));

// Custom Input for DatePicker (Time)
export const CustomTimeInput = forwardRef<HTMLButtonElement, { value?: string; onClick?: () => void }>(({
                                                                                                            value,
                                                                                                            onClick
                                                                                                        }, ref) => (
    <button
        type="button"
        className="flex items-center justify-between w-full text-left space-x-2 bg-slate-700 px-3 py-2 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        onClick={onClick}
        ref={ref}
    >
        <span>{value || 'HH:MM'}</span>
        <Clock size={18} className="text-white"/>
    </button>
));
